import { InternalUser } from "../../types/app";

export enum ContactsEntityType {
    Person = 1,
    Company = 2
  }

  export interface PersonRecord  {
    id: number;
    firstName: string;
    middleName?: string;
    lastName: string;
    personalEmail: string;
    address1: string;
    city: string;
    state: string;
    zip: string;
    history: History[];
    contactRoles: ContactRole[]
  }
  
  export interface ContactRole  {
    id: number;
    contactId: number;
    companyBranchId: number;
    roleId: number | null;
    businessEmail: string | null;
    branch: CompanyBranch | null;
    role: Role | null;
  };
  export interface CompanyBranch {
    id: number;
    companyId: number;
    isHeadquarters: boolean;
    email: string;
    phone: string;
    phoneCountryCode: string;
    countryCode: string;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    country: string | null;
    website: string;
    company: Company;
  };
  export interface Company {
    name: string;
    companyTypeId: number | null;
    id: number;
    dynamicsGuid: string;
    branches: CompanyBranch[];
    isNewCompanyEntry: boolean;
    website: string;
    tempLookupCodesFromImport: string;
    contactRoles: ContactRole[];
    email: string;
    emailPolicyTo: string;
  };
  export interface History {
    id: number;
    eventType: string;
    date: Date;
    username: string;
    company: Company;
  };
  export interface Role {
    id: number;
    name: string;
  };
export interface CompanyRecord {
  name: string;
  history: History[];
  lookupCode: string;
  type: CompanyType;
  notes: string;
  taxId: string;
}
export interface CompanyType {
  id: number;
  name: string;
};